/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DisplayCategoricalProductType,
  DisplayDefaultBrands,
  DisplayRetailProductListing,
  DisplayRetailProductOrderFromPerson,
  DisplayRetailProductOrderLineItemForPickup,
  DisplayRetailProductRefundSupportDetailsForOrder,
  DisplayRetailProductsFaqs,
  DisplayShopRetailProductListingDetails,
  DisplayStorefrontSettings,
  GetProductTypesParams,
  InitiateRetailProductRefundSupportRequest,
  PatientPickUpRetailProductItemRequest,
  RedeemRetailProductOrderRequest,
  RetrieveActiveProductListingsParams,
  RetrieveEarnedRetailProductsParams,
  RetrieveListOfDefaultBrandsByPlatformIdParams,
  RetrieveOrderedRetailProductParams,
  RetrieveProductListingsParams,
  RetrieveRetailProductOrderParams,
  RetrieveRetailProductsFaqsParams,
  RetrieveShopProductListingDetailsParams
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieves the retail product listings available to the current patient for a platform, or, when browsing anonymously, the listings sold at the location being browsed.
 */
export const retrieveProductListings = (
    platformId: string,
    params?: RetrieveProductListingsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductListing[]>(
      {url: `/api/v1/retailproducts/${platformId}/product-listings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveProductListingsQueryKey = (platformId: string,
    params?: RetrieveProductListingsParams,) => {
    return [
    `/api/v1/retailproducts/${platformId}/product-listings`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveProductListingsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveProductListings>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrieveProductListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveProductListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveProductListingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveProductListings>>> = ({ signal }) => retrieveProductListings(platformId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveProductListings>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveProductListingsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveProductListings>>>
export type RetrieveProductListingsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the retail product listings available to the current patient for a platform, or, when browsing anonymously, the listings sold at the location being browsed.
 */

export function useRetrieveProductListings<TData = Awaited<ReturnType<typeof retrieveProductListings>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrieveProductListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveProductListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveProductListingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves a paged list of a platform's active retail product listings.
 */
export const retrieveActiveProductListings = (
    platformId: string,
    params?: RetrieveActiveProductListingsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductListing[]>(
      {url: `/api/v1/retailproducts/${platformId}/active-product-listings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveActiveProductListingsQueryKey = (platformId: string,
    params?: RetrieveActiveProductListingsParams,) => {
    return [
    `/api/v1/retailproducts/${platformId}/active-product-listings`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveActiveProductListingsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveActiveProductListings>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrieveActiveProductListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveActiveProductListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveActiveProductListingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveActiveProductListings>>> = ({ signal }) => retrieveActiveProductListings(platformId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveActiveProductListings>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveActiveProductListingsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveActiveProductListings>>>
export type RetrieveActiveProductListingsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves a paged list of a platform's active retail product listings.
 */

export function useRetrieveActiveProductListings<TData = Awaited<ReturnType<typeof retrieveActiveProductListings>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrieveActiveProductListingsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveActiveProductListings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveActiveProductListingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the shop details for a specific retail product listing.
 */
export const retrieveShopProductListingDetails = (
    retailProductListingId: string,
    params?: RetrieveShopProductListingDetailsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayShopRetailProductListingDetails>(
      {url: `/api/v1/retailproducts/${retailProductListingId}/shop-product-listing-details`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveShopProductListingDetailsQueryKey = (retailProductListingId: string,
    params?: RetrieveShopProductListingDetailsParams,) => {
    return [
    `/api/v1/retailproducts/${retailProductListingId}/shop-product-listing-details`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveShopProductListingDetailsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveShopProductListingDetails>>, TError = ErrorType<unknown>>(retailProductListingId: string,
    params?: RetrieveShopProductListingDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveShopProductListingDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveShopProductListingDetailsQueryKey(retailProductListingId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveShopProductListingDetails>>> = ({ signal }) => retrieveShopProductListingDetails(retailProductListingId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: retailProductListingId !== null && retailProductListingId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveShopProductListingDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveShopProductListingDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveShopProductListingDetails>>>
export type RetrieveShopProductListingDetailsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the shop details for a specific retail product listing.
 */

export function useRetrieveShopProductListingDetails<TData = Awaited<ReturnType<typeof retrieveShopProductListingDetails>>, TError = ErrorType<unknown>>(
 retailProductListingId: string,
    params?: RetrieveShopProductListingDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveShopProductListingDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveShopProductListingDetailsQueryOptions(retailProductListingId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves all categorical product types available for retail products.
 */
export const getProductTypes = (
    params?: GetProductTypesParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayCategoricalProductType[]>(
      {url: `/api/v1/retailproducts/product-types`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetProductTypesQueryKey = (params?: GetProductTypesParams,) => {
    return [
    `/api/v1/retailproducts/product-types`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductTypesQueryOptions = <TData = Awaited<ReturnType<typeof getProductTypes>>, TError = ErrorType<unknown>>(params?: GetProductTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductTypes>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductTypes>>> = ({ signal }) => getProductTypes(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductTypes>>>
export type GetProductTypesQueryError = ErrorType<unknown>


/**
 * @summary Retrieves all categorical product types available for retail products.
 */

export function useGetProductTypes<TData = Awaited<ReturnType<typeof getProductTypes>>, TError = ErrorType<unknown>>(
 params?: GetProductTypesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductTypes>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductTypesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves a paged list of the default retail product brands for a platform.
 */
export const retrieveListOfDefaultBrandsByPlatformId = (
    platformId: string,
    params?: RetrieveListOfDefaultBrandsByPlatformIdParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayDefaultBrands[]>(
      {url: `/api/v1/retailproducts/${platformId}/default/brands`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveListOfDefaultBrandsByPlatformIdQueryKey = (platformId: string,
    params?: RetrieveListOfDefaultBrandsByPlatformIdParams,) => {
    return [
    `/api/v1/retailproducts/${platformId}/default/brands`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveListOfDefaultBrandsByPlatformIdQueryOptions = <TData = Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrieveListOfDefaultBrandsByPlatformIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveListOfDefaultBrandsByPlatformIdQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>> = ({ signal }) => retrieveListOfDefaultBrandsByPlatformId(platformId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveListOfDefaultBrandsByPlatformIdQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>>
export type RetrieveListOfDefaultBrandsByPlatformIdQueryError = ErrorType<unknown>


/**
 * @summary Retrieves a paged list of the default retail product brands for a platform.
 */

export function useRetrieveListOfDefaultBrandsByPlatformId<TData = Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrieveListOfDefaultBrandsByPlatformIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveListOfDefaultBrandsByPlatformId>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveListOfDefaultBrandsByPlatformIdQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the current patient's paged retail product order history.
 */
export const retrieveOrderedRetailProduct = (
    platformId: string,
    params?: RetrieveOrderedRetailProductParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductOrderFromPerson[]>(
      {url: `/api/v1/retailproducts/${platformId}/orders`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveOrderedRetailProductQueryKey = (platformId: string,
    params?: RetrieveOrderedRetailProductParams,) => {
    return [
    `/api/v1/retailproducts/${platformId}/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveOrderedRetailProductQueryOptions = <TData = Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrieveOrderedRetailProductParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveOrderedRetailProductQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>> = ({ signal }) => retrieveOrderedRetailProduct(platformId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveOrderedRetailProductQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>>
export type RetrieveOrderedRetailProductQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the current patient's paged retail product order history.
 */

export function useRetrieveOrderedRetailProduct<TData = Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrieveOrderedRetailProductParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveOrderedRetailProduct>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveOrderedRetailProductQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the details of a specific retail product order for the current patient.
 */
export const retrieveRetailProductOrder = (
    orderId: string,
    params?: RetrieveRetailProductOrderParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductOrderFromPerson>(
      {url: `/api/v1/retailproducts/orders/${orderId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveRetailProductOrderQueryKey = (orderId: string,
    params?: RetrieveRetailProductOrderParams,) => {
    return [
    `/api/v1/retailproducts/orders/${orderId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveRetailProductOrderQueryOptions = <TData = Awaited<ReturnType<typeof retrieveRetailProductOrder>>, TError = ErrorType<unknown>>(orderId: string,
    params?: RetrieveRetailProductOrderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveRetailProductOrder>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveRetailProductOrderQueryKey(orderId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveRetailProductOrder>>> = ({ signal }) => retrieveRetailProductOrder(orderId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveRetailProductOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveRetailProductOrderQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveRetailProductOrder>>>
export type RetrieveRetailProductOrderQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the details of a specific retail product order for the current patient.
 */

export function useRetrieveRetailProductOrder<TData = Awaited<ReturnType<typeof retrieveRetailProductOrder>>, TError = ErrorType<unknown>>(
 orderId: string,
    params?: RetrieveRetailProductOrderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveRetailProductOrder>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveRetailProductOrderQueryOptions(orderId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Redeems a retail product order using a scanned code.
 */
export const redeemRetailProductOrder = (
    redeemRetailProductOrderRequest: RedeemRetailProductOrderRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/retailproducts/redeem-order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemRetailProductOrderRequest, signal
    },
      options);
    }




export const getRedeemRetailProductOrderMutationKey = () => ['redeemRetailProductOrder'] as const;

export const getRedeemRetailProductOrderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemRetailProductOrder>>, TError,RedeemRetailProductOrderMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemRetailProductOrder>>, TError,RedeemRetailProductOrderMutationVariables, TContext> => {

const mutationKey = getRedeemRetailProductOrderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemRetailProductOrder>>, RedeemRetailProductOrderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemRetailProductOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemRetailProductOrderMutationResult = NonNullable<Awaited<ReturnType<typeof redeemRetailProductOrder>>>
    export type RedeemRetailProductOrderMutationBody = RedeemRetailProductOrderRequest
    export type RedeemRetailProductOrderMutationError = ErrorType<unknown>
    export type RedeemRetailProductOrderMutationVariables = {data: RedeemRetailProductOrderRequest}

    /**
 * @summary Redeems a retail product order using a scanned code.
 */
export const useRedeemRetailProductOrder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemRetailProductOrder>>, TError,RedeemRetailProductOrderMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof redeemRetailProductOrder>>,
        TError,
        RedeemRetailProductOrderMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemRetailProductOrderMutationOptions(options));
    }
    /**
 * @summary Indicates whether retail products are visible on the current platform's marketplace.
 */
export const areRetailProductsVisible = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<boolean>(
      {url: `/api/v1/retailproducts/are-retail-products-visible`, method: 'GET', signal
    },
      options);
    }




export const getAreRetailProductsVisibleQueryKey = () => {
    return [
    `/api/v1/retailproducts/are-retail-products-visible`
    ] as const;
    }


export const getAreRetailProductsVisibleQueryOptions = <TData = Awaited<ReturnType<typeof areRetailProductsVisible>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof areRetailProductsVisible>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAreRetailProductsVisibleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof areRetailProductsVisible>>> = ({ signal }) => areRetailProductsVisible(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof areRetailProductsVisible>>, TError, TData> & { queryKey: QueryKey }
}

export type AreRetailProductsVisibleQueryResult = NonNullable<Awaited<ReturnType<typeof areRetailProductsVisible>>>
export type AreRetailProductsVisibleQueryError = ErrorType<unknown>


/**
 * @summary Indicates whether retail products are visible on the current platform's marketplace.
 */

export function useAreRetailProductsVisible<TData = Awaited<ReturnType<typeof areRetailProductsVisible>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof areRetailProductsVisible>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAreRetailProductsVisibleQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Initiates a refund support request for a retail product order.
 */
export const initiateRetailProductRefundSupport = (
    platformId: string,
    orderId: string,
    initiateRetailProductRefundSupportRequest: InitiateRetailProductRefundSupportRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<string>(
      {url: `/api/v1/retailproducts/${platformId}/initiate-support/${orderId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateRetailProductRefundSupportRequest, signal
    },
      options);
    }




export const getInitiateRetailProductRefundSupportMutationKey = () => ['initiateRetailProductRefundSupport'] as const;

export const getInitiateRetailProductRefundSupportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateRetailProductRefundSupport>>, TError,InitiateRetailProductRefundSupportMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof initiateRetailProductRefundSupport>>, TError,InitiateRetailProductRefundSupportMutationVariables, TContext> => {

const mutationKey = getInitiateRetailProductRefundSupportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateRetailProductRefundSupport>>, InitiateRetailProductRefundSupportMutationVariables> = (props) => {
          const {platformId,orderId,data} = props ?? {};

          return  initiateRetailProductRefundSupport(platformId,orderId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiateRetailProductRefundSupportMutationResult = NonNullable<Awaited<ReturnType<typeof initiateRetailProductRefundSupport>>>
    export type InitiateRetailProductRefundSupportMutationBody = InitiateRetailProductRefundSupportRequest
    export type InitiateRetailProductRefundSupportMutationError = ErrorType<unknown>
    export type InitiateRetailProductRefundSupportMutationVariables = {platformId: string;orderId: string;data: InitiateRetailProductRefundSupportRequest}

    /**
 * @summary Initiates a refund support request for a retail product order.
 */
export const useInitiateRetailProductRefundSupport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateRetailProductRefundSupport>>, TError,InitiateRetailProductRefundSupportMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof initiateRetailProductRefundSupport>>,
        TError,
        InitiateRetailProductRefundSupportMutationVariables,
        TContext
      > => {
      return useMutation(getInitiateRetailProductRefundSupportMutationOptions(options));
    }
    /**
 * @summary Retrieves the refund support details for a retail product order.
 */
export const getRetailProductsRefundSupportDetails = (
    platformId: string,
    orderId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductRefundSupportDetailsForOrder>(
      {url: `/api/v1/retailproducts/${platformId}/refund-support-details/${orderId}`, method: 'GET', signal
    },
      options);
    }




export const getGetRetailProductsRefundSupportDetailsQueryKey = (platformId: string,
    orderId: string,) => {
    return [
    `/api/v1/retailproducts/${platformId}/refund-support-details/${orderId}`
    ] as const;
    }


export const getGetRetailProductsRefundSupportDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>, TError = ErrorType<unknown>>(platformId: string,
    orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetailProductsRefundSupportDetailsQueryKey(platformId,orderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>> = ({ signal }) => getRetailProductsRefundSupportDetails(platformId,orderId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined && orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRetailProductsRefundSupportDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>>
export type GetRetailProductsRefundSupportDetailsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the refund support details for a retail product order.
 */

export function useGetRetailProductsRefundSupportDetails<TData = Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>, TError = ErrorType<unknown>>(
 platformId: string,
    orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRetailProductsRefundSupportDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRetailProductsRefundSupportDetailsQueryOptions(platformId,orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the retail product storefront settings for the current platform.
 */
export const getStorefrontSettings = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayStorefrontSettings>(
      {url: `/api/v1/retailproducts/storefront-settings`, method: 'GET', signal
    },
      options);
    }




export const getGetStorefrontSettingsQueryKey = () => {
    return [
    `/api/v1/retailproducts/storefront-settings`
    ] as const;
    }


export const getGetStorefrontSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getStorefrontSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontSettings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorefrontSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorefrontSettings>>> = ({ signal }) => getStorefrontSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorefrontSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorefrontSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getStorefrontSettings>>>
export type GetStorefrontSettingsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the retail product storefront settings for the current platform.
 */

export function useGetStorefrontSettings<TData = Awaited<ReturnType<typeof getStorefrontSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorefrontSettings>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorefrontSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves the FAQs for a retail product for a given platform
 */
export const retrieveRetailProductsFaqs = (
    params?: RetrieveRetailProductsFaqsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductsFaqs>(
      {url: `/api/v1/retailproducts/faqs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveRetailProductsFaqsQueryKey = (params?: RetrieveRetailProductsFaqsParams,) => {
    return [
    `/api/v1/retailproducts/faqs`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveRetailProductsFaqsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>, TError = ErrorType<unknown>>(params?: RetrieveRetailProductsFaqsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveRetailProductsFaqsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>> = ({ signal }) => retrieveRetailProductsFaqs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveRetailProductsFaqsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>>
export type RetrieveRetailProductsFaqsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves the FAQs for a retail product for a given platform
 */

export function useRetrieveRetailProductsFaqs<TData = Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>, TError = ErrorType<unknown>>(
 params?: RetrieveRetailProductsFaqsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveRetailProductsFaqs>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveRetailProductsFaqsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieves a paged list of retail products the current patient has earned and can pick up.
 */
export const retrieveEarnedRetailProducts = (
    platformId: string,
    params?: RetrieveEarnedRetailProductsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayRetailProductOrderLineItemForPickup[]>(
      {url: `/api/v1/retailproducts/${platformId}/earned`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRetrieveEarnedRetailProductsQueryKey = (platformId: string,
    params?: RetrieveEarnedRetailProductsParams,) => {
    return [
    `/api/v1/retailproducts/${platformId}/earned`, ...(params ? [params] : [])
    ] as const;
    }


export const getRetrieveEarnedRetailProductsQueryOptions = <TData = Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>, TError = ErrorType<unknown>>(platformId: string,
    params?: RetrieveEarnedRetailProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveEarnedRetailProductsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>> = ({ signal }) => retrieveEarnedRetailProducts(platformId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type RetrieveEarnedRetailProductsQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>>
export type RetrieveEarnedRetailProductsQueryError = ErrorType<unknown>


/**
 * @summary Retrieves a paged list of retail products the current patient has earned and can pick up.
 */

export function useRetrieveEarnedRetailProducts<TData = Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>, TError = ErrorType<unknown>>(
 platformId: string,
    params?: RetrieveEarnedRetailProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof retrieveEarnedRetailProducts>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getRetrieveEarnedRetailProductsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Records a patient's pickup of retail product items.
 */
export const patientPickUpRetailProductItems = (
    platformId: string,
    patientPickUpRetailProductItemRequest: PatientPickUpRetailProductItemRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/retailproducts/${platformId}/pickup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPickUpRetailProductItemRequest, signal
    },
      options);
    }




export const getPatientPickUpRetailProductItemsMutationKey = () => ['patientPickUpRetailProductItems'] as const;

export const getPatientPickUpRetailProductItemsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPickUpRetailProductItems>>, TError,PatientPickUpRetailProductItemsMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof patientPickUpRetailProductItems>>, TError,PatientPickUpRetailProductItemsMutationVariables, TContext> => {

const mutationKey = getPatientPickUpRetailProductItemsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPickUpRetailProductItems>>, PatientPickUpRetailProductItemsMutationVariables> = (props) => {
          const {platformId,data} = props ?? {};

          return  patientPickUpRetailProductItems(platformId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPickUpRetailProductItemsMutationResult = NonNullable<Awaited<ReturnType<typeof patientPickUpRetailProductItems>>>
    export type PatientPickUpRetailProductItemsMutationBody = PatientPickUpRetailProductItemRequest
    export type PatientPickUpRetailProductItemsMutationError = ErrorType<unknown>
    export type PatientPickUpRetailProductItemsMutationVariables = {platformId: string;data: PatientPickUpRetailProductItemRequest}

    /**
 * @summary Records a patient's pickup of retail product items.
 */
export const usePatientPickUpRetailProductItems = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPickUpRetailProductItems>>, TError,PatientPickUpRetailProductItemsMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patientPickUpRetailProductItems>>,
        TError,
        PatientPickUpRetailProductItemsMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPickUpRetailProductItemsMutationOptions(options));
    }
